import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getClasses, getArticles } from "../services/api";
import { imgUrl } from "../services/supabase";
import Sidebar from "../components/Sidebar";
import "./Home.css";

// Imagen por defecto cuando una clase no tiene thumbnail
const DEFAULT_THUMB = "https://pub-49a3e9f914ad427789951636484495f5.r2.dev/Images/bioestadistica-probiol_1200_1200%20(1).jpg";

// Slides genéricos de fallback — URLs de Unsplash, NO consumen tu egress
const FALLBACK_SLIDES = [
  {
    url: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=1400&q=80",
    title: "Bioestadística aplicada a la salud",
    desc: "Aprende métodos cuantitativos con ejemplos reales de investigación médica.",
    path: "/clases",
  },
  {
    url: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1400&q=80",
    title: "Análisis de datos clínicos",
    desc: "Domina las herramientas estadísticas que todo profesional de la salud necesita.",
    path: "/clases",
  },
  {
    url: "https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=1400&q=80",
    title: "Investiga con rigor científico",
    desc: "Plataforma de aprendizaje para investigadores y estudiantes del área de salud.",
    path: "/clases",
  },
];

/* ── SVG Icons ───────────────────────────────────────────────── */
function IconClases() {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="5" width="32" height="22" rx="3" fill="#0e8a8a" opacity="0.15"/>
      <rect x="3" y="5" width="32" height="22" rx="3" stroke="#0e8a8a" strokeWidth="2"/>
      <line x1="9" y1="12" x2="29" y2="12" stroke="#0e8a8a" strokeWidth="2" strokeLinecap="round"/>
      <line x1="9" y1="17" x2="24" y2="17" stroke="#0e8a8a" strokeWidth="1.5" strokeLinecap="round" opacity="0.7"/>
      <line x1="9" y1="21" x2="20" y2="21" stroke="#0e8a8a" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
      <line x1="19" y1="27" x2="19" y2="33" stroke="#0e8a8a" strokeWidth="2" strokeLinecap="round"/>
      <line x1="13" y1="33" x2="25" y2="33" stroke="#0e8a8a" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}

function IconRecursos() {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="8" width="20" height="26" rx="2" fill="#0e8a8a" opacity="0.12"/>
      <rect x="5" y="8" width="20" height="26" rx="2" stroke="#0e8a8a" strokeWidth="2"/>
      <line x1="10" y1="8" x2="10" y2="34" stroke="#0e8a8a" strokeWidth="1.5" opacity="0.5"/>
      <line x1="14" y1="15" x2="22" y2="15" stroke="#0e8a8a" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="14" y1="19" x2="22" y2="19" stroke="#0e8a8a" strokeWidth="1.5" strokeLinecap="round" opacity="0.7"/>
      <line x1="14" y1="23" x2="19" y2="23" stroke="#0e8a8a" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
      <rect x="18" y="5" width="16" height="24" rx="2" fill="#4a5c2f" opacity="0.1" stroke="#4a5c2f" strokeWidth="1.5"/>
      <line x1="22" y1="5" x2="22" y2="29" stroke="#4a5c2f" strokeWidth="1.2" opacity="0.4"/>
    </svg>
  );
}

function IconArticulos() {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 4h16l8 8v22a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" fill="#0e8a8a" opacity="0.12" stroke="#0e8a8a" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M23 4v8h8" stroke="#0e8a8a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
      <line x1="10" y1="18" x2="28" y2="18" stroke="#0e8a8a" strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="10" y1="23" x2="28" y2="23" stroke="#0e8a8a" strokeWidth="1.8" strokeLinecap="round" opacity="0.7"/>
      <line x1="10" y1="28" x2="20" y2="28" stroke="#0e8a8a" strokeWidth="1.8" strokeLinecap="round" opacity="0.5"/>
    </svg>
  );
}

function IconArticuloItem({ isPdf }) {
  return isPdf ? (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 2h12l6 6v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" fill="#0e8a8a" opacity="0.18" stroke="#0e8a8a" strokeWidth="1.6" strokeLinejoin="round"/>
      <path d="M16 2v6h6" stroke="#0e8a8a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
      <rect x="3" y="14" width="14" height="7" rx="1.5" fill="#0e8a8a"/>
      <text x="10" y="20" textAnchor="middle" fontSize="4.5" fontWeight="700" fill="white" fontFamily="sans-serif">PDF</text>
    </svg>
  ) : (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 2h12l6 6v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" fill="#0e8a8a" opacity="0.18" stroke="#0e8a8a" strokeWidth="1.6" strokeLinejoin="round"/>
      <path d="M16 2v6h6" stroke="#0e8a8a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
      <line x1="7" y1="13" x2="19" y2="13" stroke="#0e8a8a" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="7" y1="17" x2="19" y2="17" stroke="#0e8a8a" strokeWidth="1.5" strokeLinecap="round" opacity="0.7"/>
      <line x1="7" y1="21" x2="14" y2="21" stroke="#0e8a8a" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    </svg>
  );
}

/* ── Carrusel ── */
function HeroCarousel({ slides }) {
  const [current, setCurrent] = useState(0);
  const [fading,  setFading]  = useState(false);
  const timer = useRef(null);

  const goTo = (idx) => {
    if (idx === current) return;
    setFading(true);
    setTimeout(() => { setCurrent(idx); setFading(false); }, 400);
  };

  const next = () => goTo((current + 1) % slides.length);
  const prev = () => goTo((current - 1 + slides.length) % slides.length);

  useEffect(() => {
    timer.current = setInterval(next, 5500);
    return () => clearInterval(timer.current);
  }, [current, slides.length]);

  const slide = slides[current] || FALLBACK_SLIDES[0];

  return (
    <div className="hero-carousel">
      <div
        className={`hero-bg ${fading ? "fading" : ""}`}
        style={{ backgroundImage: `url(${slide.url})` }}
      />
      <div className="hero-overlay" />

      <div className={`hero-content ${fading ? "fading" : ""}`}>
        <p className="hero-eyebrow">STATISTIKDATA</p>
        <h1 className="hero-title">{slide.title}</h1>
        {slide.desc && <p className="hero-desc">{slide.desc}</p>}
        <div className="hero-cta-row">
          <button
            className="hero-btn-primary"
            onClick={() => window.location.href = slide.path || "/clases"}
          >
            Ver clases
          </button>
        </div>
      </div>

      {slides.length > 1 && (
        <>
          <button className="hero-arrow left"  onClick={prev} aria-label="Anterior">‹</button>
          <button className="hero-arrow right" onClick={next} aria-label="Siguiente">›</button>
          <div className="hero-dots">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`hero-dot ${i === current ? "active" : ""}`}
                onClick={() => goTo(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

function SkeletonCard({ wide }) {
  return (
    <div className="skel" style={{ minHeight: wide ? 130 : 80 }}>
      {wide && <div className="skel-line" style={{ width:"100%", height:80, marginBottom:8, borderRadius:6 }} />}
      <div className="skel-line" style={{ width:"60%", height:12, marginBottom:7 }} />
      <div className="skel-line" style={{ width:"100%", height:10, marginBottom:5 }} />
      <div className="skel-line" style={{ width:"80%", height:10 }} />
    </div>
  );
}

const FEATURE_CARDS = [
  { icon:<IconClases />,    title:"Clases",    desc:"Lecciones estructuradas, ejemplos prácticos y evaluaciones.", path:"/clases"    },
  { icon:<IconRecursos />,  title:"Recursos",  desc:"Videos, diapositivas, PDFs y material complementario.",       path:"/recursos"  },
  { icon:<IconArticulos />, title:"Artículos", desc:"Publicaciones actualizadas y aplicaciones reales en salud.",  path:"/articulos" },
];

export default function Home() {
  const [classes,  setClasses]  = useState([]);
  const [articles, setArticles] = useState([]);
  const [slides,   setSlides]   = useState(FALLBACK_SLIDES);
  const [loadingC, setLoadingC] = useState(true);
  const [loadingA, setLoadingA] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getClasses()
      .then((data) => {
        const all = data.slice(0, 6);
        setClasses(all.slice(0, 3));

        // Construir slides con clases que tienen thumbnail
        // imgUrl.hero comprime la imagen para reducir egress del carrusel
        const withImg = all.filter((c) => c.thumbnail_url);
        if (withImg.length >= 2) {
          setSlides(withImg.slice(0, 4).map((c) => ({
            url:   imgUrl.hero(c.thumbnail_url),
            title: c.title,
            desc:  c.description || "",
            path:  `/clases/${c.id}`,
          })));
        }
        // Si hay menos de 2 clases con imagen usa FALLBACK_SLIDES (Unsplash)
      })
      .finally(() => setLoadingC(false));

    getArticles()
      .then((d) => setArticles(d.slice(0, 3)))
      .finally(() => setLoadingA(false));
  }, []);

  return (
    <div className="page">
      <HeroCarousel slides={slides} />

      <section className="home-features">
        {FEATURE_CARDS.map((f) => (
          <div
            className="home-feature-card"
            key={f.title}
            onClick={() => navigate(f.path)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate(f.path)}
          >
            <span className="home-feature-icon">{f.icon}</span>
            <h3>{f.title}</h3>
            <p>{f.desc}</p>
          </div>
        ))}
      </section>

      <div className="two-col">
        <main>

          {/* Clases recientes */}
          <section className="home-section">
            <div className="home-section-header">
              <h2 className="home-section-title">Clases recientes</h2>
              <button className="home-section-link" onClick={() => navigate("/clases")}>Ver todas →</button>
            </div>
            <div className="home-classes-grid">
              {loadingC
                ? [1,2,3].map((n) => <SkeletonCard key={n} wide />)
                : classes.length === 0
                  ? <p style={{ color:"var(--text-muted)", fontSize:"0.85rem", gridColumn:"1/-1" }}>No hay clases publicadas aún.</p>
                  : classes.map((c) => (
                      <div
                        className="home-class-card"
                        key={c.id}
                        onClick={() => navigate(`/clases/${c.id}`)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && navigate(`/clases/${c.id}`)}
                      >
                        <div className="home-class-thumb">
                          <img
                            src={imgUrl.card(c.thumbnail_url || DEFAULT_THUMB)}
                            alt={c.title}
                          />
                        </div>
                        <div className="home-class-body">
                          <h4>{c.title}</h4>
                          <p>{c.description}</p>
                          <span className="home-read-more">Seguir leyendo →</span>
                        </div>
                      </div>
                    ))
              }
            </div>
          </section>

          {/* Artículos recientes */}
          <section className="home-section">
            <div className="home-section-header">
              <h2 className="home-section-title">Artículos recientes</h2>
              <button className="home-section-link" onClick={() => navigate("/articulos")}>Ver todos →</button>
            </div>
            <div className="home-articles-list">
              {loadingA
                ? [1,2,3].map((n) => <SkeletonCard key={n} />)
                : articles.length === 0
                  ? <p style={{ color:"var(--text-muted)", fontSize:"0.85rem" }}>No hay artículos publicados aún.</p>
                  : articles.map((a) => (
                      <div
                        className="home-article-item"
                        key={a.id}
                        onClick={() => navigate(`/articulos/${a.id}`)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && navigate(`/articulos/${a.id}`)}
                      >
                        <div className="home-article-icon">
                          <IconArticuloItem isPdf={!!a.pdf_url} />
                        </div>
                        <div className="home-article-body">
                          <h4>{a.title}</h4>
                          <p>{a.description}</p>
                          <span className="home-article-date">
                            {new Date(a.created_at).toLocaleDateString("es-PE", { year:"numeric", month:"short", day:"numeric" })}
                          </span>
                        </div>
                        <span style={{ color:"var(--teal)", alignSelf:"center", flexShrink:0 }}>→</span>
                      </div>
                    ))
              }
            </div>
          </section>

        </main>
        <Sidebar />
      </div>
    </div>
  );
}